import setup from './moduleSetup';

export default {
    name: 'dashboard',
    before: [],
    after: [],
    setup,
};
